<template>
  <v-container class="pa-3" fluid>
    <v-row>
      <v-col cols="10" lg="10" md="10" style="margin-left:  auto; margin-right: auto;">
        <v-row>
          <v-col cols="12" lg="12" md="12" class="d-flex">
            <v-row>
              <v-col cols="12" lg="12" md="12">
                <span style="color: #222222; font-size: 25px; font-weight: 500;">Time Off Report</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: 20px;">
      <v-col cols="12" lg="10" md="10" style="margin-left:  auto; margin-right: auto;">
        <v-row class="d-flex">
          <v-col cols="12" lg="4" md="4" style="padding-right: 20px;">
            <v-row>
              <v-col cols="12" lg="12" md="12">
                <v-autocomplete v-model="datasearch.employeename" :items="emp_list" item-text="name" item-value="id"
                  label="Employee Name" clearable @click:clear="
                    $nextTick(() => {
                      datasearch.employeename = '';
                    })
                    " outlined dense></v-autocomplete>
                <!-- :disabled="employeeisdisable" -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="4" md="4" style="padding-left: 20px;">
            <v-row>
              <v-col cols="12" lg="12" md="12">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    datasearch.department = 0;
                  })
                  " v-model="datasearch.department" :items="department_list" label="Department"
                  item-text="department_name" item-value="id" outlined dense
                  @change="OnSearchDepartment"></v-autocomplete>
                <!-- :disabled="disabledDep" -->
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="4" md="4" style="padding-right: 20px;">
            <v-row>
              <v-col cols="12" lg="12" md="12">
                <v-autocomplete v-model="datasearch.leave_type" :items="leave_type_list" item-text="leave_type"
                  item-value="id" label="Leave Type" clearable @click:clear="
                    $nextTick(() => {
                      datasearch.leave_type = 0;
                    })
                    " outlined dense></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: -20px;">
      <v-col cols="12" lg="10" md="10" style="margin-left:  auto; margin-right: auto;">
        <v-row class="d-flex ">
          <v-col cols="12" lg="4" md="4" style="padding-left: 20px;">
            <v-row style="margin-top: -30px;">
              <v-col cols="12" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">From</span>
                <v-menu v-model="menudatefrom" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFromFormatted" append-icon="mdi-calendar" readonly dense outlined
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="datasearch.datefrom" @input="menudatefrom = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">To</span>
                <v-menu v-model="menudateto" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateToFormatted" append-icon="mdi-calendar" readonly dense outlined
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="datasearch.dateto" @input="menudateto = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="4" md="4" style="padding-left: 20px;padding-top: 20px;">
            <v-btn style="
                      color: white;
                      background-color: #0A7EA5;
                      width: 120px;
                    " @click="SearchAlldata">
              <v-icon left>mdi-magnify</v-icon> Search</v-btn>
          </v-col>

          <v-col align="end" cols="12" lg="4" md="4" style="padding-left: 20px;padding-top: 20px;">
            <v-btn outlined class="btnexport" style="
                      width: 120px;
                    " @click="previewPDF()">
              <v-icon left>mdi-printer</v-icon>print</v-btn>
          </v-col>
          <!-- <v-col
            align="end"
            cols="12"
            lg="4"
            md="4"
            style="padding-left: 20px;padding-top: 20px;"
          >
            <xlsx-workbook @change="onChange" @created="onCreated">
              <xlsx-sheet
                :collection="sheet.data"
                v-for="sheet in sheets"
                :key="sheet.name"
                :sheet-name="sheet.name"
              />
              <xlsx-download :filename="exportleavequota">
                <v-btn
                  outlined
                  class="btnexport"
                  style="
                            width: 120px;
                          "
                  @click="ChechData()"
                >
                  <v-icon small center>mdi-export</v-icon>
                  <span>Export</span>
                </v-btn>
              </xlsx-download>
            </xlsx-workbook>
          </v-col> -->
        </v-row>
      </v-col>
    </v-row>

    <v-row style="margin-top: 30px;">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;">
        <v-data-table dense :search="search" :headers="headers" :items="mDataArray" :expanded.sync="expanded"
          :single-expand="true" show-expand class="elevation-1   595959">

          <template v-slot:item.fullnameen="{ item }">
            {{ item.fullnameen ? item.fullnameen : item.fullnameth }}
          </template>
          <template v-slot:item.remark="{ item }">
            <span v-if="
              item.total_day_sickleave >= 5 ||
              item.total_percent_sickleave >= 50
            " class="orange--text">
              Monitor Sick Leave
            </span>
            <!-- v-else-if="
                item.total_useleave >= item.total_quota ||
                  item.total_percent > 100
              " -->
            <span v-else-if="item.leave_logs_details.length == 0" class="red--text">
              No Leave Taken
            </span>
            <span v-else-if="item.total_percent > 90" class="red--text">
              Approaching Limit
            </span>
            <span v-else-if="item.total_percent >= 70 && item.total_percent <= 90" class="orange--text">
              Monitor Usage
            </span>
            <span v-else-if="item.total_percent < 70" class="green--text">
              OK
            </span>
          </template>

          <template v-slot:item.actions="{ item }"> </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <p class="mt-6">
                Leave Breakdown: {{ computedDateFromFormatted }} -
                {{ computedDateToFormatted }}
              </p>
              <p class="ma-0" v-for="data in item.leave_details">
                {{ data.leave_type }}: {{ data.use_leave_text }} (Allowed:
                {{ data.quota_text }})
              </p>
              <p class="mb-6"></p>
              <p class="ma-0">
                Total Leave: {{ item.total_useleave_text }} / {{ item.total_quota_text }}
                -> {{ item.total_percent_text }}
              </p>
              <p class="ma-0">Remark:
                <span v-if="
                  item.total_day_sickleave >= 5 ||
                  item.total_percent_sickleave >= 50
                " class="orange--text">
                  Monitor Sick Leave
                </span>
                <!--   v-else-if="
                  item.total_useleave >= item.total_quota ||
                    item.total_percent > 100
                " -->
                <span v-else-if="item.leave_logs_details.length == 0" class="red--text">
                  No Leave Taken
                </span>
                <span v-else-if="item.total_percent > 90" class="red--text">
                  Approaching Limit
                </span>
                <span v-else-if="item.total_percent >= 70 && item.total_percent <= 90" class="orange--text">
                  Monitor Usage
                </span>
                <span v-else-if="item.total_percent < 70" class="green--text">
                  OK
                </span>
              </p>
              <p class="mb-6"></p>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "../services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
  utils,
} from "vue-xlsx";
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  mixins: [reactiveProp],
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    await this.loadEmp();
    await this.loadCustomer();
    await this.loadJobtitle();
    await this.loadLeaveType();
    await this.loadDepartmentByCompanyId();
    await this.loadCompany();
    await this.waitForPdfMake();
    this.$hideLoader();
  },
  components: {
    SuccessDialog,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      dataforprint: {
        "title": "Dej-Udom & Associates Ltd.",
        "subtitle": "Employee Time Off Report"
      },
      header: {
        "employee_name": "Guppiya Sooklumkirn",
        "employee_name_th": "กัปปิย สุขล้ำเกิน",
        "position": "Developer",
        "department": "Corporate",
        "period": "02 January 2025 - 30 July 2025",
        "report_date": "25 August 2025",
        "total_leave_taken": "17 Days 4 Hr",
        "total_leave_quota": "47 Days",
        "total_adjacent_holiday": 2,
        "remark": "Monitor Usage"
      },
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      leave_type_list: [],
      expanded: [],
      employeeisdisable: false,
      exportleavequota: "leavereport.xlsx",
      sheetName: "Time Off Report",
      sheets: [
        {
          name: "leavereport",
          data: [],
        },
      ],

      search: "",
      headers: [
        {
          text: "Employee Name",
          value: "fullnameen",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Department",
          value: "department_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Leaves Taken",
          value: "total_useleave_text",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Total",
          value: "total_quota_text",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "% Used",
          value: "total_percent_text",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Remark",
          value: "remark",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "",
          value: "data-table-expand",
          class: "bg-colorth tabletextwhite",
        },
      ],
      mDataArray: [],
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        employeename: "",
        department: 0,
        leave_type: 0,
        // datefrom: "",
        // dateto: "",
        datefrom: (() => {
          let date = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          );

          // ปรับเวลาให้เป็น timezone +7
          let timezoneOffset = 7 * 60; // +7 ชั่วโมง (ในนาที)
          let adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);

          // แปลงเป็นรูปแบบ YYYY-MM-DD
          return adjustedDate.toISOString().substr(0, 10);
        })(),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        // company_id: 13,
        company_id: localStorage.getItem(server.COMPANYID),
      },
      dateCurrent: this.formatDateday(new Date().toISOString().substr(0, 10)),
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",

      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
      dataformatpr: {
        title: "",
        subtitle: "Time Off Report",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
      },
      disabledDep: false,
      dataforprint: {
        title: "Dej-Udom & Associates Ltd.",
        subtitle: "Employee Time Off Report",
        details_left1: "Employee: ",
        details_left2: "Position: ",
        details_left3: "Department: ",
        details_left4: "Period: ",
        details_left5: "Report Date: ",
        details_right1: "Total Leave Taken: ",
        details_right2: "Total Leave Quota: ",
        details_right3: "Total Adjacent to Holiday: ",
        details_right4: "Remark: ",
        title_graph: "Leaves Taken Days (Monthly)",
        leave_summary: "Leave Summarry",
        leave_log_details: "Leaves Log Details",
      },
    };
  },
  methods: {
    async ChechData() {
      if (this.mDataArray.length < 1) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Cannot Export",
          "Please search before exporting.",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    async getBackList() {
      this.$router.push(`/approver-time-off`);
    },
    onCreated(wb) {
      // console.log(wb);
    },
    onChange(wb) {
      // console.log("wb-------------");
      // console.log(wb);
      const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
      wb.Sheets.leavereport.A1 = {
        t: "s",
        v: `Export Time Off Report as of   ${unity.formatDate(
          this.datasearch.datefrom
        )} to  ${unity.formatDate(this.datasearch.dateto)}`,
      };

      wb.Sheets.leavereport.B1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.C1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.D1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.E1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.F1 = { t: "s", v: "" };

      wb.Sheets.leavereport.A3 = { t: "s", v: "Employee Name" };
      wb.Sheets.leavereport.B3 = { t: "s", v: "Leave Type" };
      wb.Sheets.leavereport.C3 = { t: "s", v: "date time from" };
      wb.Sheets.leavereport.D3 = { t: "s", v: "date time to" };
      wb.Sheets.leavereport.E3 = { t: "s", v: "Amount" };
      wb.Sheets.leavereport.F3 = { t: "s", v: "Description" };

      wb.Sheets.leavereport["!merges"] = merge;
    },

    async loadLeaveType() {
      const result = await api.getLeaveTypeAll(
        Number(localStorage.getItem(server.COMPANYID))
      );
      this.leave_type_list = result.data;
    },

    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      // if (localStorage.getItem(server.ROLE) == "EMPLOYEE") {
      //   result.data.filter((x, index) => {
      //     if (x.id == localStorage.getItem(server.USER_ID)) {
      //       this.emp_list = x;
      //       this.datasearch.employeename = x.id;
      //       this.employeeisdisable = true;
      //     }
      //   });
      // } else {
      this.emp_list = result.data;
      //   this.employeeisdisable = false;
      // }
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListByCompany(
        localStorage.getItem(server.COMPANYID)
      );
      this.customer_list = result.data;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );
      this.dataforprint.title = copany_datat.data[0].name;
    },
    async loadDepartmentByCompanyId() {
      // if (
      //   Number(localStorage.getItem(server.AUTHORIZE_ID)) != 9 &&
      //   Number(localStorage.getItem(server.AUTHORIZE_ID)) != 52
      // ) {
      //   this.datasearch.department = Number(
      //     localStorage.getItem(server.DEPARTMENT_ID)
      //   );
      //   this.disabledDep = true;
      // }
      let result = await api.getNewAllDepartment_By_CompanyID(this.mycompany_id);
      this.department_list = result.data;
    },
    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {
        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },
    async OnSearchDepartment() {
      // console.log(this.datasearch.department);
    },
    async SearchAlldata() {
      this.datashowAll = [];
      this.mDataArray = [];

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "No Results Found",
          "We can’t find any item matching your search",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "No Results Found",
          "We can’t find any item matching your search",
          "text-h5 red--text text-center"
        );
        return;
      }
      this.lengthAlldatasearch = 0;
      this.datashowAll = [];

      this.$showLoader();
      let resultsearch = await api.newsearchleavereport({
        params: this.datasearch,
      });
      // console.log(JSON.stringify(resultsearch.data[1]));
      if (resultsearch.data.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "No Results Found",
          "We can’t find any item matching your search",
          "text-h5 red--text text-center"
        );
        this.$hideLoader();
        return;
      } else {

        resultsearch.data.forEach(async (x, i) => {
          if (x.leave_details.length > 0) {
            x.leave_details.map(async (o, ii) => {
              x.leave_details[ii].use_leave_text = o.use_leave ? await this.dayToText(
                o.use_leave
              ) : "0 Day";
              x.leave_details[ii].quota_text = o.quota ? await this.dayToText(o.quota) : "0 Day";
            });
            const sickLeave = x.leave_details.find(
              (item) => item.leave_type === "Sick Leave"
            );
            if (sickLeave) {
              const percent_sickleave =
                (sickLeave.use_leave / sickLeave.quota) * 100;
              x.total_day_sickleave = sickLeave.use_leave;
              x.total_percent_sickleave = percent_sickleave;
            }
            const totalQuota = x.leave_details.reduce(
              (sum, item) => sum + item.quota,
              0
            );
            const totalUseLeave = x.leave_details.reduce(
              (sum, item) => sum + item.use_leave,
              0
            );
            const totalpercent =
              totalQuota > 0 ? (totalUseLeave / totalQuota) * 100 : 0;
            x.total_quota = totalQuota;
            x.total_useleave = totalUseLeave;
            x.total_percent = totalpercent;
            x.total_quota_text = totalQuota ? await this.dayToText(totalQuota) : "0 Day";
            x.total_useleave_text = totalUseLeave ? await this.dayToText(totalUseLeave) : "0 Day";
            x.total_percent_text = totalpercent.toFixed(2) + "%";

            this.mDataArray.push(x);
          }
          this.$hideLoader();
        });
        // console.log(this.mDataArray);

        // this.dataforshowprpo = resultsearch.data;
        // this.dataforshowprpo.forEach(async(x,index) => {
        //     x.forEach(i=>{
        //       if(i.summarize !== true){
        //         this.mDataArray.push(i);
        //       }
        //     })
        //     this.dataforshowprpo = x
        //     await this.checkcontent(this.dataforshowprpo);
        // })
        // await this.setexporttoxlsx();
      }
    },
    async setexporttoxlsx() {
      let setexportxlsx = [{}, {}];
      this.mDataArray.forEach((x, index) => {
        setexportxlsx.splice(index + 2, 0, {
          employee: x.fullnameth,
          leave_type: x.leave_type_name,
          date_time_from_show: x.date_time_from_show,
          date_time_to_show: x.date_time_to_show,
          leave_time: x.leave_time,
          description: x.description,
        });
      });
      this.sheets[0].data = setexportxlsx;
    },

    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();
      let element = document.getElementById("mydivhtmltobase");

      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          // console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          // var filtered = pdf.internal.pages.filter(function(el) {
          //   return el != null;
          // });

          // pdf.internal.pages = filtered;
          // for (let i = 0; i < totalPages; i++) {
          //   if (i == totalPages - 1) {
          //     pdf.internal.pages.splice(i, 1);
          //   }
          // }
          // pdf.addPage();

          // console.log(pdf);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      // console.log(blob);
      // let formData = new FormData();
      // formData.append(`file`, blob, "test.pdf");
      // const resultadd = api.creatememoMaster(formData);
      // console.log(resultadd);

      // };
    },
    async dayToText(value) {
      const hoursPerDay = 8; // ถ้าบริษัทคุณใช้ 7.5 หรือ 9 ชม. แก้ตรงนี้ได้

      const days = Math.floor(value);
      const hours = Math.round((value - days) * hoursPerDay);

      const dayText = days > 1 ? `${days} days` : `${days} day`;
      const hourText = hours > 1 ? `${hours} hrs` : `${hours} hr`;

      if (days > 0 && hours > 0) return `${dayText} ${hourText}`;
      if (days > 0) return dayText;
      return hourText;
    },
    generateBarChart(months, values) {
      const maxValue = Math.max(...values, 10); // ค่าสูงสุดอย่างน้อย 10
      const chartHeight = 200;
      const chartWidth = 500;
      const barWidth = (chartWidth / months.length) - 8;
      const baseY = chartHeight + 20;
      const startX = 30;

      let canvas = [];

      // วาดเส้นแกน Y และ Grid Lines
      for (let i = 0; i <= 10; i++) {
        const y = 20 + (chartHeight / 10) * (10 - i);

        // เส้น Grid แนวนอน
        canvas.push({
          type: 'line',
          x1: startX,
          y1: y,
          x2: startX + chartWidth,
          y2: y,
          lineWidth: 0.5,
          lineColor: '#e0e0e0'
        });

        // ตัวเลขแกน Y
        canvas.push({
          type: 'text',
          text: `${Math.round((i * maxValue) / 10)}`,
          x: startX - 20,
          y: y - 3,
          fontSize: 8,
          color: '#666666'
        });
      }

      // วาดแท่งกราฟและชื่อเดือน
      months.forEach((month, i) => {
        const barHeight = (values[i] / maxValue) * chartHeight;
        const x = startX + (i * (barWidth + 8));
        const y = baseY - barHeight;

        // แท่งกราฟ
        canvas.push({
          type: 'rect',
          x: x,
          y: y,
          w: barWidth,
          h: barHeight,
          color: '#757575'
        });

        // ชื่อเดือน (ตัดให้สั้นลง)
        const shortMonth = month.substring(0, 3);
        canvas.push({
          type: 'text',
          text: shortMonth,
          x: x + (barWidth / 2) - 10,
          y: baseY + 10,
          fontSize: 7,
          color: '#000000'
        });
      });

      return canvas;
    },
    async waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert(
            "ไม่สามารถโหลดระบบ PDF ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต"
          );
        }
      }, 10000);
    },
    async generateDocDefinition(datajsonprint) {
      const mainStatement = await this.generateMainStatement(datajsonprint);

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 20, 40, 20],
        content: mainStatement,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    async previewPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = await this.generateDocDefinition(this.mDataArray);
        pdfMake.createPdf(docDefinition).open();
        console.log("✅ เปิดตัวอย่าง PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },
    async prepareChartData(leaveLogsDetails) {
      const months = this.months;

      // สร้าง array สำหรับเก็บจำนวนวันลาของแต่ละเดือน
      const values = new Array(12).fill(0);

      if (!leaveLogsDetails || leaveLogsDetails.length === 0) {
        return { months, values };
      }

      // วนลูปนับจำนวนวันลาในแต่ละเดือน
      leaveLogsDetails.forEach(log => {
        if (log.date_time_from_show) {
          // แปลงวันที่จาก format DD/MM/YYYY
          const dateParts = log.date_time_from_show.split(' ')[0].split('/');
          if (dateParts.length === 3) {
            const month = parseInt(dateParts[1]) - 1; // เดือน 0-11

            // แปลง leave_time เป็นตัวเลข (เช่น "1 Day" -> 1, "4 Hrs" -> 0.5)
            const duration = this.parseLeaveDuration(log.leave_time);
            values[month] += duration;
          }
        }
      });
      return { months, values };
    },
    async generateMainStatement(datajsonprint) {
      let mainContent = [];

      // ===== หน้าที่ 1: Employee Time Off Report =====
      datajsonprint.forEach(async (x, i) => {
        const chartData = await this.prepareChartData(x.leave_logs_details);
        mainContent.push(
          // Header บริษัท + CONFIDENTIAL
          {
            columns: [
              {
                width: "*",
                stack: [
                  {
                    text: "",
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
              {
                width: 100,
                text: "CONFIDENTIAL",
                fontSize: 10,
                bold: true,
                color: "red",
                fillColor: "red",
                alignment: "center",
                margin: [0, 0, 0, 0],
              },
            ],
            margin: [0, 0, 0, 0],
          },
          {
            stack: [
              {
                text: this.dataforprint.title || "",
                fontSize: 16,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
              {
                text: this.dataforprint.subtitle || "",
                fontSize: 10,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              },
            ],
            margin: [0, 0, 0, 0],
          },

          // ข้อมูลพนักงาน (Employee Information)
          {
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: [
                      { text: this.dataforprint.details_left1, fontSize: 9, bold: true },
                      { text: x.fullnameen ? x.fullnameen : x.fullnameth || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left2, fontSize: 9, bold: true },
                      { text: x.position_name || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left3, fontSize: 9, bold: true },
                      { text: x.department_name || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left4, fontSize: 9, bold: true },
                      { text: `${this.computedDateFromFormatted} - ${this.computedDateToFormatted}` || "", fontSize: 9 },
                    ],
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_left5, fontSize: 9, bold: true },
                      {
                        text: this.dateCurrent || new Date().toLocaleDateString("en-GB"),
                        fontSize: 9,
                      },
                    ],
                  },
                ],
              },
              {
                width: "50%",
                stack: [
                  {
                    text: [
                      { text: "\u00A0", fontSize: 9, bold: true },
                      { text: "\u00A0", fontSize: 9 },
                    ],
                    alignment: "right",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_right1, fontSize: 9, bold: true },
                      { text: x.total_useleave_text || "0 Days", fontSize: 9 },
                    ],
                    alignment: "right",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_right2, fontSize: 9, bold: true },
                      { text: x.total_quota_text || "0 Days", fontSize: 9 },
                    ],
                    alignment: "right",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_right3, fontSize: 9, bold: true },
                      { text: x.leave_logs_details ? x.leave_logs_details.filter(item => item.holiday !== undefined).length : 0 || 0, fontSize: 9 },
                    ],
                    alignment: "right",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: [
                      { text: this.dataforprint.details_right4, fontSize: 9, bold: true },
                      {
                        text: this.getRemarkWording(x) || "OK",
                        fontSize: 9,
                        color: this.getRemarkColor(x)
                      },
                    ],
                    alignment: "right",
                  },
                ],
              },
            ],
            margin: [0, 0, 0, 20],
          },

          // กราฟ Leaves Taken Days (Monthly) - Placeholder
          {
            stack: [
              {
                text: this.dataforprint.title_graph,
                fontSize: 12,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 0],
              }
            ],
            margin: [0, 0, 0, 0],
          },
          // {
          //   text: "Leaves Taken Days (Monthly)",
          //   fontSize: 12,
          //   bold: true,
          //   margin: [0, 0, 0, 10],
          // },
          {
            columns: [
              {
                width: 30,
                stack: this.generateYAxisLabels(chartData.values),
                margin: [0, 5, 0, 0]
              },
              {
                width: '*',
                stack: [
                  {
                    canvas: this.generateBarChartCanvas(chartData.months, chartData.values),
                    margin: [0, 0, 0, 5]
                  },
                  {
                    columns: this.generateXAxisLabels(chartData.months),
                    margin: [0, 5, 0, 0]
                  }
                ]
              }
            ],
            margin: [0, 0, 0, 0],
          },
          {
            text: this.dataforprint.leave_summary,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10],
          },

          // Leave Summary Table
          {
            table: {
              headerRows: 1,
              widths: ["*", 100, 100, 60],
              body: [
                [
                  {
                    text: "Leave Type",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Leaves Taken",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Leave Quota",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "% Used",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [5, 5, 5, 5],
                  },
                ],
                ...x.leave_details.map((item) => [
                  {
                    text: item.leave_type || "",
                    fontSize: 9,
                    bold: item.leave_type === "Total",
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: item.use_leave_text || "0 Day",
                    fontSize: 9,
                    bold: item.leave_type === "Total",
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: item.quota_text || "0 Day",
                    fontSize: 9,
                    bold: item.leave_type === "Total",
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: item.percent || "0%",
                    fontSize: 9,
                    bold: item.leave_type === "Total",
                    margin: [1, 1, 1, 1],
                  },
                ],),

                // แล้วค่อย push แถว Total ต่อท้าย
                [
                  { text: "Total", fontSize: 9, bold: true, margin: [1, 1, 1, 1] },
                  { text: x.total_useleave_text || "0 Day", fontSize: 9, margin: [1, 1, 1, 1] },
                  { text: x.total_quota_text || "0 Day", fontSize: 9, margin: [1, 1, 1, 1] },
                  { text: x.total_percent_text || "0%", fontSize: 9, margin: [1, 1, 1, 1] },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                // เส้นบนสุด (i == 0) และเส้นล่างสุด (i == node.table.body.length)
                // return (i === 0 || i === node.table.body.length) ? 1 : 0;
                return 1;
              },
              vLineWidth: function (i, node) {
                // เส้นซ้ายสุด (i == 0) และ ขวาสุด (i == node.table.widths.length)
                return (i === 0 || i === node.table.widths.length) ? 1 : 0;
              },
              // hLineWidth: function (i, node) {
              //   return 1;
              // },
              // vLineWidth: function (i, node) {
              //   return 1;
              // },
              hLineColor: function (i, node) {
                return '#000000';
              },
              vLineColor: function (i, node) {
                return '#000000';
              }
            },
            // layout: "lightHorizontalLines",
            margin: [0, 0, 0, 20],
          },

          // Page Break
          // { text: "", pageBreak: "before" },

          // ===== หน้าที่ 2: Leave Log Details =====

          // Header บริษัท (ซ้ำ)
          // {
          //   columns: [
          //     {
          //       width: "*",
          //       stack: [
          //         {
          //           text: this.dataforprint.title || "Dej-Udom & Associates Ltd.",
          //           fontSize: 16,
          //           bold: true,
          //           margin: [0, 0, 0, 2],
          //         },
          //         {
          //           text: this.dataforprint.subtitle || "Employee Time Off Report",
          //           fontSize: 10,
          //           margin: [0, 0, 0, 0],
          //         },
          //       ],
          //     },
          //     {
          //       width: 100,
          //       text: "CONFIDENTIAL",
          //       fontSize: 10,
          //       bold: true,
          //       color: "white",
          //       fillColor: "red",
          //       alignment: "center",
          //       margin: [0, 0, 0, 0],
          //     },
          //   ],
          //   margin: [0, 0, 0, 10],
          // },

          // ชื่อพนักงาน
          // {
          //   text: [
          //     { text: "Employee: ", fontSize: 10 },
          //     { text: this.header.employee_name || "", fontSize: 10, bold: true },
          //   ],
          //   margin: [0, 0, 0, 20],
          // },

          // Leave Log Details Title
          {
            text: this.dataforprint.leave_log_details,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 10],
          },

          // Leave Log Details Table
          {
            table: {
              headerRows: 1,
              widths: [120, 60, 60, 100, 135],
              body: [
                [
                  {
                    text: "Date",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Duration",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Leave Type",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Adjacent to Holiday?",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                  {
                    text: "Leave Reason",
                    fontSize: 10,
                    bold: true,
                    fillColor: "#cccccc",
                    margin: [1, 5, 1, 5],
                  },
                ],
                ...x.leave_logs_details.map((log) => [
                  {
                    text: `${log.date_time_from_show} - ${log.date_time_to_show}` || "-",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: log.leave_time || "0 Day",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: log.leave_type_name || "",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: log.holiday ? `Yes - ${log.holiday[0].date_show} (${log.holiday[0].h_name})` : "" || "",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                  {
                    text: log.description || "",
                    fontSize: 8,
                    margin: [1, 1, 1, 1],
                  },
                ]),
              ],
            },
            // layout: "lightHorizontalLines",
            layout: {
              hLineWidth: function (i, node) {
                // เส้นบนสุด (i == 0) และเส้นล่างสุด (i == node.table.body.length)
                // return (i === 0 || i === node.table.body.length) ? 1 : 0;
                return 1;
              },
              vLineWidth: function (i, node) {
                // เส้นซ้ายสุด (i == 0) และ ขวาสุด (i == node.table.widths.length)
                return (i === 0 || i === node.table.widths.length) ? 1 : 0;
              },
              // hLineWidth: function (i, node) {
              //   return 1;
              // },
              // vLineWidth: function (i, node) {
              //   return 1;
              // },
              hLineColor: function (i, node) {
                return '#000000';
              },
              vLineColor: function (i, node) {
                return '#000000';
              }
            },
          },
          { text: "", pageBreak: i == this.mDataArray.length - 1 ? undefined : "before" },

        );
        if (i == this.mDataArray.length - 1) {
          //  return mainContent;
        }
      });
      return mainContent;

    },

    // Helper method สำหรับกำหนดสี Remark
    getRemarkWording(item) {
      if (item.total_day_sickleave >= 5 || item.total_percent_sickleave >= 50) {
        return "Monitor Sick Leave";
      }
      // else if(item.total_useleave >= item.total_quota || item.total_percent > 100){
      else if (item.leave_logs_details.length == 0) {
        return "No Leave Taken";
      }
      else if (item.total_percent > 90) {
        return "Approaching Limit";
      }
      else if (item.total_percent >= 70 && item.total_percent <= 90) {
        return "Monitor Usage";
      }
      else if (item.total_percent < 70) {
        return "OK";
      } else {
        return "";
      }
    },
    getRemarkColor(item) {
      if (item.total_day_sickleave >= 5 || item.total_percent_sickleave >= 50) {
        return "orange";
      }
      // else if(item.total_useleave >= item.total_quota || item.total_percent > 100){
      else if (item.leave_logs_details.length == 0) {
        return "red";
      }
      else if (item.total_percent > 90) {
        return "red";
      }
      else if (item.total_percent >= 70 && item.total_percent <= 90) {
        return "orange";
      }
      else if (item.total_percent < 70) {
        return "green";
      } else {
        return "black";
      }
    },
    parseLeaveDuration(leaveTime) {
      if (!leaveTime) return 0;

      let totalDays = 0;

      // ตรวจสอบว่ามี "Day" หรือ "Days"
      const dayMatch = leaveTime.match(/(\d+)\s*Days?/i);
      if (dayMatch) {
        totalDays += parseInt(dayMatch[1]);
      }

      // ตรวจสอบว่ามี "Hr" หรือ "Hrs"
      const hourMatch = leaveTime.match(/(\d+)\s*Hrs?/i);
      if (hourMatch) {
        const hours = parseInt(hourMatch[1]);
        totalDays += hours / 8; // แปลงชั่วโมงเป็นวัน (8 ชม. = 1 วัน)
      }

      return totalDays;
    },
    getRandomInt() {
      let randoms = [];
      for (let index = 0; index < 12; index++) {
        randoms.push(Math.floor(Math.random() * (50000 - 5 + 1)) + 5);
      }
      return randoms;
    },
    generateYAxisLabels(values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const labels = [];

      for (let i = 10; i >= 0; i--) {
        const y = ((10 - i) * chartHeight) / 10;

        labels.push({
          text: `${Math.round((i * maxValue) / 10)}`,
          fontSize: 8,
          alignment: 'left',
          absolutePosition: { x: 55, y: y + 160 }, // ปรับ x, y ตามตำแหน่งจริง
          margin: [0, 0, 0, 0]
        });
      }

      return labels;
    },

    // ฟังก์ชันสร้าง X-axis labels
    generateXAxisLabels(months) {
      return months.map(month => ({
        width: '*',
        text: month.substring(0, 3),
        fontSize: 7,
        alignment: 'center'
      }));
    },

    // ฟังก์ชันสร้าง canvas สำหรับแท่งกราฟและ grid เท่านั้น
    generateBarChartCanvas(months, values) {
      const maxValue = Math.max(...values, 10);
      const chartHeight = 150;
      const chartWidth = 480;
      const barWidth = (chartWidth / months.length) - 8;
      const baseY = chartHeight;
      const colors = [
        "#EF5350",
        "#AB47BC",
        "#5C6BC0",
        "#42A5F5",
        "#26C6DA",
        "#66BB6A",
        "#9CCC65",
        "#FFA726",
        "#FF7043",
        "#8D6E63",
        "#EC407A",
        "#29B6F6"
      ];

      let canvas = [];

      // วาด Grid Lines แนวนอน
      for (let i = 0; i <= 10; i++) {
        const y = (chartHeight / 10) * (10 - i);

        canvas.push({
          type: 'line',
          x1: 0,
          y1: y,
          x2: chartWidth,
          y2: y,
          lineWidth: 0.5,
          lineColor: '#e0e0e0'
        });
      }

      // วาดแท่งกราฟ
      months.forEach((month, i) => {
        const barHeight = (values[i] / maxValue) * chartHeight;
        const x = i * (barWidth + 8) + 4;
        const y = baseY - barHeight;

        canvas.push({
          type: 'rect',
          x: x,
          y: y,
          w: barWidth,
          h: barHeight,
          color: '#757575'
          // color: colors[i]
          // color:'#' + Math.floor(Math.random()*16777215).toString(16)
        });
      });
      return canvas;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.borderblockpr {
  border: 2px solid black;
  width: 100px;
  height: 150px;
  background: white;
  box-sizing: border-box;
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  border-top: 2px solid black;
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 2px solid black;
}

td {
  /* border: 1px solid black; */
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width35 {
  word-wrap: break-word;
  width: 35%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
                body.A3.landscape { width: 420mm }
                body.A3, body.A4.landscape { width: 297mm }
                body.A4, body.A5.landscape { width: 210mm }
                body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 90%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fontsize10 {
  font-size: 10px;
}

.v-btn:not(.v-btn--round).v-size--default.btnimport {
  background-color: #ffffff;
  color: #25b360;
}

.v-btn:not(.v-btn--round).v-size--default.btnexport {
  background-color: #ffffff;
  color: #33a4c0;
}
</style>
